export let sortAlphabetical = (property, regexString) => (a, b) => {
    if (!(property in a && property in b)) {
        throw new Error(`Sorting property ${property} missing.`)
    }

    if (!regexString) regexString = /(.*)/;

    let aRegex = new RegExp(regexString);
    let bRegex = new RegExp(regexString);

    let aResult = aRegex.exec(a[property]);
    let bResult = bRegex.exec(b[property]);

    if (!aResult || !bResult) {
        throw new Error(`Sorting regex failed.`)
    }

    let aProp = aResult[1].toLowerCase();
    let bProp = bResult[1].toLowerCase();

    if (aProp < bProp) {
        return -1;
    }
    else if (aProp > bProp) {
        return 1;
    }
    else {
        return 0;
    }
}